export interface ValidateAstSettingsRequestPayloadDto {
  IpAddressOrDns: string;
  Username: string;
  Password: string;
  TimeOutInMilliseconds: number;
}

export const DefaultValidateAstSettingsRequestPayloadDto: ValidateAstSettingsRequestPayloadDto =
  {
    IpAddressOrDns: "",
    Username: "",
    Password: "",
    TimeOutInMilliseconds: 30000,
  };
